import React, { FC } from "react";
import { Status } from "../../../types";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface StatusBarProps {
  status: Status;
}

export const StatusBar: FC<StatusBarProps> = ({ status }) => {
  const { t } = useTranslation();
  const getBackgroundColor = () => {
    if (status === "STARTING") {
      return "rgba(6, 174, 212, 0.12)";
    }
    if (status === "NEW") {
      return "rgba(6, 174, 212, 0.12)";
    }
    if (status === "IN_PROGRESS") {
      return "rgba(6, 174, 212, 0.12)";
    }
    if (status === "PAUSED") {
      return "rgba(247, 144, 9, 0.12)";
    }
    if (status === "PENDING") {
      return "rgba(247, 144, 9, 0.12)";
    }
    if (status === "CHECKING") {
      return "rgba(99, 102, 241, 0.12)";
    }
    if (status === "COMPLETED") {
      return "rgba(16, 185, 129, 0.12)";
    }
    if (status === "CANCELED") {
      return "rgba(240, 68, 56, 0.12)";
    }
    if (status === "ERROR") {
      return "rgba(240, 68, 56, 0.12)";
    }
    if (status === "FAILED") {
      return "rgba(240, 68, 56, 0.12)";
    }
  };

  const getTextColor = () => {
    if (status === "NEW") {
      return "rgb(14, 112, 144)";
    }
    if (status === "STARTING") {
      return "rgb(14, 112, 144)";
    }
    if (status === "IN_PROGRESS") {
      return "rgb(14, 112, 144)";
    }
    if (status === "PAUSED") {
      return "rgb(181, 71, 8)";
    }
    if (status === "PENDING") {
      return "rgb(181, 71, 8)";
    }
    if (status === "CHECKING") {
      return "rgb(67, 56, 202)";
    }
    if (status === "COMPLETED") {
      return "rgb(11, 129, 90)";
    }
    if (status === "CANCELED") {
      return "rgb(180, 35, 24)";
    }
    if (status === "ERROR") {
      return "rgb(180, 35, 24)";
    }
    if (status === "FAILED") {
      return "rgb(180, 35, 24)";
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mr: "8px",
      }}
    >
      <Typography
        sx={{
          fontSize: "0.8125rem",
          display: "flex",
          alignItems: "center",
          backgroundColor: getBackgroundColor(),
          color: getTextColor(),
          px: "8px",
          borderRadius: "16px",
          height: "24px",
          whiteSpace: "nowrap",
        }}
      >
        {t(`status.${status}`)}
      </Typography>
    </Box>
  );
};
